import { ChangeDetectionStrategy, Component, computed, inject, input, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { Day } from '../../../utils/date.interface';
import { CalendarService } from '../services/calendar.service';

@Component({
  selector: 'fcom-calendar-month',
  styleUrls: ['./month.component.scss'],
  templateUrl: './month.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet],
})
export class MonthComponent {
  private calendarService = inject(CalendarService);

  value = input.required<string>();
  dayTemplate = input<TemplateRef<{ day: Day }>>();
  isDateRange = input<boolean>();
  /** If we need to display empty weeks */
  showEmptyWeeks = input<boolean>();

  month = computed(() => this.calendarService.getMonth(this.value()));

  onKeyDown(event: KeyboardEvent): void {
    this.calendarService.processKey(event);
  }
}
